function isString(value) {
    return typeof value === 'string' || value instanceof String
}

function formatNumber(number){
    return number? number.toString().replace('.',',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, "."):''

}
export {isString,formatNumber}